var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('div',{staticClass:"content"},[_c('Side'),_c('main',{staticClass:"main",class:{'main-bg': _vm.isAnnounce}},[_c('router-view',{staticClass:"child-view"})],1)],1),_c('footer',{staticClass:"mainFooter"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }